import { render, staticRenderFns } from "./AddKitchenPrinter.vue?vue&type=template&id=7cf01a77&"
import script from "./AddKitchenPrinter.vue?vue&type=script&lang=js&"
export * from "./AddKitchenPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports